import { AsyncState, createAsyncStateReducer } from "react-async-stateful";

import * as NotificationActions from "./Notifications.action";

import * as ReduxUtils from "../../lib/util/ReduxUtils";

export interface NotificationReducerState {
	notifications: AsyncState<{
		[groupName: string]: {
			active: any[];
			complete: any[];
		};
	}>;
}

const initialState: NotificationReducerState = {
	notifications: AsyncState.create({ __group: { active: [], complete: [] } }),
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<NotificationReducerState>({
		notifications: NotificationActions.getGroupNotifications.type,
	}),
	ReduxUtils.createReducerMap({
		[NotificationActions.updateNotification.type]: (state, action) => {
			const { fleetId, groupId, notification } = action.payload;
			const currentNotifications = state.notifications.value || {};
			const groupKey = groupId ? `${fleetId}/${groupId}` : fleetId;
			const groupNotifications = currentNotifications[groupKey];

			if (groupNotifications) {
				const index = groupNotifications.active.findIndex(
					(n) => n.id === notification.id,
				);

				if (index !== -1) {
					state.notifications.value![groupKey].active[index] = {
						...groupNotifications.active[index],
						...notification,
					};
				}
			}

			return state;
		},
	}),
]);
